export const homeObjTwo = {
  id: "about",
  lightBg: false,
  lightText: true,
  lighttextDesc: true,
  topLine: "Zašto baš mi?",
  headline: "Saznajte što sve nudimo.",
  description:
    "Prednost naše usluge je sistem ,,ključ u ruke’’ čime je kompletna briga oko atesta prepuštena nama, od pregleda vozila uz savjetovanje, izrade elaborata do pripreme cijele dokumentacije za potrebe atesta. Pomoću navedenog, naši klijenti imat će zakonski atestirana vozila koja se mogu uredno registrirati na tehničkom pregledu. Sva usluga vrši se na području RH sa sjedištem u Puli, a moguć je i izlazak na teren radi pregleda (neregistrirana vozila).",
  buttonLabel: "Pogledaj galeriju",
  imgStart: false,
  img: require("../../images/paper.svg").default,
  alt: "Automobil",
  dark: true,
  primary: true,
  darkText: false,
};
